import type { ActionSidebarViewType } from "./constants";
import { ACTION_SIDEBAR_VIEW_MAP } from "./constants";

export const isTypographyTokenType = (
  token: string,
): token is ActionSidebarViewType => token in ACTION_SIDEBAR_VIEW_MAP;
